import { useUserInfo } from '@/hooks/useUserInfo';
import React, { useEffect, useRef, useState } from 'react';
import { getSummary } from "@/utils/pasUtils.js";
import { any, object } from 'zod';
import {
  Printer
} from "lucide-react";
import { useLocation } from 'react-router-dom';

const MeExport = () => {
  const VITE_USERNAMET = import.meta.env.VITE_USERNAMET
  const VITE_PASSWORD = import.meta.env.VITE_PASSWORD
  
  const location = useLocation();
  const { greeting, fullName, email, role, profilePictureUrl } = useUserInfo();


  // console.log(email);

  const printableRef = useRef<HTMLDivElement>(null);

  const [data, setData] = useState({
    profile: null,
    loading: true,
    error: null

  });

  useEffect(() => {
    async function fetchSalaryData() {
      try {
        const summaryResponse = await getSummary(VITE_USERNAMET, VITE_PASSWORD, email);
        if (data.loading) {
          setData(prev => ({
            ...prev,
            profile: summaryResponse.profile,
            loading: false,
            error: null
          }));

          // console.log(data)
        }
      } catch (err) {
        setData(prev => ({
          ...prev,
          loading: false,
          error: err.message
        }));
      }
      finally {
        // setLoading(false);
      }
    }

    fetchSalaryData();

    
  }, [data.loading, email]);

  const handlePrint = () => {
    if (!printableRef.current) return; // Add null check

    const printContent = printableRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContents;
  };

  // Logo SVG component
  const Logo = () => (
    <img src="/src/assets/logo-dark.svg" className='w-36 text-left' />
  );
  const Signature = () => (
    <div className='relative w-max mx-auto'>
      <img src="/src/assets/wsmstamp.png" className='absolute w-48 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-50 ' />
      <div className="flex flex-col items-center justify-center">
        <h1 className='text-2xl font-bold mt-4'>إدارة الموارد البشرية</h1>
        <h1 className='text-2xl font-bold'>HR Department</h1>
      </div>

    </div>
  );

  const DataAr = () => {

    return (
      <div>
        <ul>
          <li>رقم الموظف
            <strong> {data.profile.name} </strong>
          </li>
          <li>
            اسم الموظف
            <strong> {data.profile.full_name_arabic} </strong>
          </li>
          <li>
            الاسم الأول
            <strong> {data.profile.custom_first_name_ar} </strong>
          </li>
          <li>
            الاسم الثاني
            <strong> {data.profile.custom_second_name_ar} </strong>
          </li>
          <li>
            الاسم الأخير
            <strong> {data.profile.custom_third_name_ar} </strong>
          </li>
          <li>
            الجوال
            <strong> {data.profile.cell_number} </strong>
          </li>
          <li>
            الجنسية
            <strong> {data.profile.nationality_arabic} </strong>
          </li>
          <li>
            تاريخ التوظيف
            <strong> {data.profile.date_of_joining} </strong>
          </li>
          <li>
            الوصف الوظيفي
            <strong> {data.profile.designation_arabic} </strong>
          </li>
          <li>
            المدير المباشر
            <strong> {data.profile.repport_to? data.profile.repport_to:'غير محدد'} </strong>
          </li>
          <li>
            جهة اتصال الطوارئ
            <strong> {data.profile.person_to_be_contacted? data.profile.person_to_be_contacted:'غير محدد'} </strong>
          </li>
          <li>
            رقم هاتف الطوارئ
            <strong> {data.profile.emergency_phone_number && data.profile.emergency_phone_number !== '0' ? data.profile.emergency_phone_number:'غير محدد'} </strong>
          </li>
          <li>
            علاقة جهة الاتصال
            <strong> {data.profile.relation? data.profile.relation: 'غير محدد'} </strong>
          </li>
          <li>
            المسمى الوظيفي في الإقامة
            <strong> {data.profile.iqama_profession_arabic} </strong>
          </li>
        </ul>
      </div >
    );
  }
  const DataEn = () => {

    return (
      <div>
        <ul>
          <li>employee ID
            <strong> {data.profile.name} </strong>
          </li>
          <li>
            employee name
            <strong> {data.profile.employee_name} </strong>
          </li>
          <li>
            first name
            <strong> {data.profile.first_name} </strong>
          </li>
          <li>
            middle name
            <strong> {data.profile.middle_name} </strong>
          </li>
          <li>
            last name
            <strong> {data.profile.last_name} </strong>
          </li>
          <li>
            cell number
            <strong> {data.profile.cell_number} </strong>
          </li>
          <li>
            nationality
            <strong> {data.profile.nationality} </strong>
          </li>
          <li>
            date of joining
            <strong> {data.profile.date_of_joining} </strong>
          </li>
          <li>
            designation
            <strong> {data.profile.designation} </strong>
          </li>
          <li>
            reports to
            <strong> {data.profile.repport_to? data.profile.repport_to:'undefinded'} </strong>
          </li>
          <li>
            emergency contact person
            <strong> {data.profile.person_to_be_contacted? data.profile.person_to_be_contacted:'undefinded'} </strong>
          </li>
          <li>
            emergency phone number
            <strong> {data.profile.emergency_phone_number && data.profile.emergency_phone_number !== '0'? data.profile.emergency_phone_number: 'undefinded'} </strong>
          </li>
          <li>
            emergency contact relation
            <strong> {data.profile.relation? data.profile.relation:'undefinded'} </strong>
          </li>
          <li>
            iqama profession
            <strong> {data.profile.iqama_profession_english} </strong>
          </li>
        </ul>
      </div >
    )
  };

  const BilingualAREBDataRow = () => {
    if (data.loading) return <div className='flex justify-center'><img src="/src/assets/spinner.gif" alt="Loading..." /></div>;
    if (data.error) return <div>Error: {data.error}</div>;
    return (
      <div className='flex py-3'>
        <div className='w-1/2 p-4'>
          <p className="text-gray-600 mt-2">التاريخ: {new Date().toLocaleDateString()}</p>
          <div className="font-normal text-gray-700 mt-3">تحية طيبة،</div>
          <div className="font-normal text-gray-700 mt-3 text-justify">نفيدكم ببيانات السيد/ة <strong>{data.profile.full_name_arabic}</strong> 
            <br /><hr/><br />
            <DataAr />
            <br />
          </div>
        </div>
        <div className="flex-1 pl-4 text-left w-1/2 p-4" dir="ltr">
          <p className="text-gray-600 mt-2">Date: {new Date().toLocaleDateString()}</p>
          {/* <div className="font-normal text-gray-700 mt-3 underline">To Whome it may concern</div> */}
          {/* <div className="font-normal text-gray-700 mt-3 underline">To Whome it may concern: {employeeData.presentedTo}</div> */}
          <div className="font-normal text-gray-700 mt-3">Greating,</div>
          <div className="font-normal text-gray-700 mt-3 text-justify">This to inform you the info for Mr/Mrs <strong>{data.profile.employee_name}</strong>
            <br /><hr/><br />
            <DataEn />
            
          </div>
        </div>
      </div>
    );
  };

 

  
  return (

    <div dir='rtl' className="min-h-full bg-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg overflow-hidden">
        {/* Printable content */}
        <div ref={printableRef} id="printable-content" className="p-8">
          {/* Header with logo and title */}
          <div className="flex justify-between items-start mb-8">
            <div className="w-full"></div> {/* Spacer for balance */}
            <Logo />
          </div>
          <div className="text-center flex-1">
            <h2 className="text-xl font-bold text-gray-800 mt-2" dir="rtl">معلوماتي</h2>
            <h1 className="text-2xl font-bold text-gray-800">My Info</h1>
          </div>
          <div className="mb-8">
            <BilingualAREBDataRow />
          </div>

          <div className='flex justify-center'>
            {/* <Signature /> */}
          </div>
        </div>
        {/* Print button */}
        <div className="flex justify-center p-6 bg-gray-50 border-t border-gray-200 print:hidden">
          <button
            onClick={handlePrint}
            className="w-48 bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors"
          >
            <Printer className="h-5 w-5" />
            طباعة
          </button>
        </div>
      </div>
    </div>
  );
};

export default MeExport;